import React from 'react';
import styled from 'styled-components';

import { getColorForIcons } from './styleFunctions';

const StyledSVG = styled.svg`
  z-index: 1;
  position: relative;
  height: ${(props) => (props.isMobile ? '50px' : '70px')};
  path {
    fill: ${(props) => props.fillColor};
  }
`;

const StatusIcon = ({ status, id, isMobile }) => {
  let fillColor = getColorForIcons(status);

  return (
    <StyledSVG
      id={id}
      width="112"
      height="88"
      isMobile={isMobile}
      viewBox="0 0 112 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.88086 41.5155L41.8872 19.9186C50.5981 14.6938 61.4019 14.6938 70.1128 19.9186L106.119 41.5155C113.96 46.2187 113.96 57.7813 106.119 62.4845L70.1128 84.0814C61.4019 89.3062 50.5981 89.3062 41.8872 84.0814L5.88086 62.4845C-1.96029 57.7813 -1.96029 46.2187 5.88086 41.5155Z"
        fill={fillColor}
      />
      <path
        d="M8.82948 42.0282L43.5836 21.4076C51.2412 16.8641 60.7588 16.8641 68.4164 21.4076L103.171 42.0282C108.276 45.0578 108.276 52.4671 103.171 55.4966L66.9264 77.0013C60.1877 80.9996 51.8123 80.9996 45.0736 77.0013L8.82948 55.4966C3.72351 52.4671 3.72351 45.0578 8.82948 42.0282Z"
        fill="url(#paint0_radial_3520_7158)"
      />
      <path
        d="M34 4C34 1.79086 35.7909 0 38 0L60 0L78 18V52C78 54.2091 76.2091 56 74 56H38C35.7909 56 34 54.2091 34 52V4Z"
        fill={fillColor}
      />
      <path d="M60 0V14.7273C60 16.5355 61.4645 18 63.2727 18H78L60 0Z" fill="url(#paint1_linear_3520_7158)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.9144 25.3938C56.9644 25.1639 57.1678 25 57.403 25H59.3796C59.6986 25 59.936 25.2946 59.8682 25.6062L55.0856 47.6062C55.0356 47.8361 54.8322 48 54.597 48H52.6204C52.3014 48 52.064 47.7054 52.1318 47.3938L56.9144 25.3938ZM48.6548 31.1298C48.574 31.0467 48.4644 31 48.3501 31C48.2358 31 48.1262 31.0467 48.0453 31.1298L43.1262 36.1867C43.0454 36.2698 43 36.3825 43 36.5C43 36.6175 43.0454 36.7302 43.1262 36.8133L48.0453 41.8702C48.2136 42.0433 48.4865 42.0433 48.6548 41.8702L49.8738 40.6171C50.0421 40.4441 50.0421 40.1636 49.8738 39.9906L46.4783 36.5L49.8738 33.0094C50.0421 32.8364 50.0421 32.5559 49.8738 32.3829L48.6548 31.1298ZM63.6499 31C63.5356 31 63.426 31.0467 63.3452 31.1298L62.1262 32.3829C61.9579 32.5559 61.9579 32.8364 62.1262 33.0094L65.5217 36.5L62.1262 39.9906C61.9579 40.1636 61.9579 40.4441 62.1262 40.6171L63.3452 41.8702C63.5135 42.0433 63.7864 42.0433 63.9547 41.8702L68.8738 36.8133C68.9546 36.7302 69 36.6175 69 36.5C69 36.3825 68.9546 36.2698 68.8738 36.1867L63.9547 31.1298C63.8738 31.0467 63.7642 31 63.6499 31Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_3520_7158"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(56 55.2969) rotate(90) scale(21.7969 35.8594)"
        >
          <stop stopColor="white" stopOpacity="0.7" />
          <stop offset="1" stopColor="white" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_3520_7158"
          x1="69"
          y1="6"
          x2="59.6703"
          y2="17.2906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.2" />
        </linearGradient>
      </defs>
    </StyledSVG>
  );
};

export default StatusIcon;
